import React from "react";
import plus from "../../assets/img/plus-square.png";
import delete_outline from "../../assets/img/delete_outline.png";
import Icon from "../../assets/img/Icon.png";
import "./UploadMedia1.css";
import { NavLink } from "react-router-dom";
import { StateContext } from "../../store/StateProvider";
const index = () => {
  const [state, dispatch] = StateContext();
  return (
    <section id="upload-" class="upload- py-5">
      <div class="container-fluid max-width mx-auto">
        <div class="row">
          <div class="col-12">
            <NavLink to="/creator" className="float-end">
              <img src={state.items.circle} alt="close button" />
            </NavLink>
          </div>
          <div class="col-10 mx-auto mt-5 pt-5 mx-0 d-flex justify-content-between flex-wrap">
            <div class="col-10 col-md-5 col-lg-3 mx-auto my-2 py-5 ms-lg-0 upload-box- d-flex justify-content-center">
              <button type="submit" class="btn upload-btn- py-2">
                Upload MP3
              </button>
            </div>
            <div class="col-10 col-md-5 col-lg-3 mx-auto my-2 py-5 upload-box- d-flex justify-content-center">
              <button type="submit" class="btn upload-btn- py-2">
                Upload Zip
              </button>
            </div>
            <div class="col-10 col-md-6 col-lg-4 mx-auto my-2 py-5 me-lg-0 upload-box- d-flex justify-content-center">
              <button type="submit" class="btn upload-btn- py-2">
                Ulpload Art (Jpeg, Png, Gif, Mp4)
              </button>
            </div>
          </div>
          <div class="col-10 mx-auto mt-5">
            <label for="text" class="text-white pb-3 upload-box1-label-">
              Description
            </label>
            <textarea name="text" id="" class="form-control upload-box1-">
              Say somthing about your uploaded content
            </textarea>
          </div>
          <div class="col-10 mx-auto mt-5">
            <div class="row justify-content-between">
              <div class="col-md-5 my-2">
                <label
                  for="datetime-local"
                  class="upload-box3-text- pb-4 fw-light"
                >
                  Drop Date & Time
                </label>
                <div className="upload-placeholder-">
                  <input type="text" className="upload-box3-  form-control" />
                  <div className="placeholder-datetime-">
                    <input
                      type="date"
                      className="upload-btn-background-"
                      placeholder="10-12-2022"
                    />
                    <input
                      type="time"
                      className="upload-btn-background- me-3"
                      placeholder="04:00 PM"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-10 mt-md-5 mx-auto">
            <div class="row justify-content-between">
              <div class="col-md-5 mt-5 mt-md-0">
                <div class="d-flex justify-content-between pb-3">
                  <div class="upload-box3-text- pb-3">Wallet Address</div>
                  <div>
                    <img src={plus} alt="plus sign" />
                  </div>
                </div>
                {/* <!-- table start --> */}
                <div class="col-sm-12">
                  <table class="table table-bordered table-text-">
                    <thead class="table-head-color-">
                      <tr>
                        <th></th>
                        <th>Address</th>
                        <th>Share</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody class="table-body-text-">
                      <tr>
                        <th>1</th>
                        <td>xxxx-yyyy-0101-jjjjs</td>
                        <td>9.5%</td>
                        <td>
                          <a href="/UploadMedia">
                            <img src={delete_outline} alt="delete icon" />
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>2</th>
                        <td>0202-8693-kkkp-pppk</td>
                        <td>2.5%</td>
                        <td>
                          <a href="/UploadMedia">
                            <img src={delete_outline} alt="delete icon" />
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* <!-- table End --> */}
              </div>
            </div>
          </div>
          <div class="col-10 max-width mx-auto mt-5">
            <div class="row">
              <div class="col-12">
                <div class="SubmitBtnWrapper-">
                  <button class="SubmitBtn- py-2">
                    <span class="me-2">Submit</span>
                    <img src={Icon} alt="upload icon" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default index;
